<app-banner-home></app-banner-home>
<app-about-us></app-about-us>
<!-- <app-team-members-home></app-team-members-home> -->
<section class="locations-section" id="locaciones">
  <div class="container locations-section__container">
    <header class="locations-section__header">
      <h2 class="locations-section__title">Nuestras locaciones</h2>
      <p class="locations-section__lead">
        A lo largo de nuestro crecimiento, hemos fortalecido nuestra presencia en distintas regiones del país, consolidando operaciones estratégicas que nos permiten brindar un servicio cercano, ágil y de alta calidad.
      </p>
    </header>

    <div class="locations-grid">
      <article class="location-card">
        <div class="location-card__map">
          <button
            *ngIf="!showMapCdmx"
            type="button"
            class="location-card__link"
            (click)="enableMap('cdmx')"
          >
            Cargar mapa
          </button>
          <iframe
            *ngIf="showMapCdmx"
            title="Mapa CDMX"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=19.362156693046916,-99.13447109816131&output=embed&hl=es&z=16"
          ></iframe>
        </div>
        <div class="location-card__body">
          <h3 class="location-card__city">CDMX</h3>
          <p class="location-card__address">CALLE H MZ V #18 COLONIA EDUCACIÓN, C.P. 04400, COYOACÁN, CIUDAD DE MÉXICO.</p>
          <a
            class="location-card__link"
            href="https://www.google.com/maps/search/?api=1&query=19.362156693046916,-99.13447109816131"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver en Google Maps
          </a>
        </div>
      </article>

      <article class="location-card">
        <div class="location-card__map">
          <button
            *ngIf="!showMapToluca"
            type="button"
            class="location-card__link"
            (click)="enableMap('toluca')"
          >
            Cargar mapa
          </button>
          <iframe
            *ngIf="showMapToluca"
            title="Mapa Toluca"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=19.389362445741074,-99.17566982814616&output=embed&hl=es&z=16"
          ></iframe>
        </div>
        <div class="location-card__body">
          <h3 class="location-card__city">Toluca</h3>
          <p class="location-card__address">PASEO TOLLOCAN #119 COLONIA PILARES, C.P. 52179, TOLUCA, ESTADO DE MÉXICO.</p>
          <a
            class="location-card__link"
            href="https://www.google.com/maps/search/?api=1&query=19.389362445741074,-99.17566982814616"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver en Google Maps
          </a>
        </div>
      </article>

      <article class="location-card">
        <div class="location-card__map">
          <button
            *ngIf="!showMapOaxaca"
            type="button"
            class="location-card__link"
            (click)="enableMap('oaxaca')"
          >
            Cargar mapa
          </button>
          <iframe
            *ngIf="showMapOaxaca"
            title="Mapa Oaxaca"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=17.05157501148244,-96.70004732516283&output=embed&hl=es&z=16"
          ></iframe>
        </div>
        <div class="location-card__body">
          <h3 class="location-card__city">Oaxaca</h3>
          <p class="location-card__address">CALICANTO #102 COLONIA 3RA SECCION LA SOLEDAD, C.P. 71236, SAN ANTONIO DE LA CAL, OAXACA.</p>
          <a
            class="location-card__link"
            href="https://www.google.com/maps/search/?api=1&query=17.05157501148244,-96.70004732516283"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver en Google Maps
          </a>
        </div>
      </article>
    </div>
  </div>
</section>
<app-how-do-we-build></app-how-do-we-build>
<app-our-values></app-our-values>
<!-- <app-credibility></app-credibility> -->
<app-mision></app-mision>
<app-trayectoria></app-trayectoria>
<app-manifiesto></app-manifiesto>
<app-why-choose-us-home></app-why-choose-us-home>
<!-- <app-team-members-home></app-team-members-home> -->
<app-we-build-trust></app-we-build-trust>
<!-- <app-stats></app-stats>  -->
<!-- <app-we-are-universal-home></app-we-are-universal-home> -->
<!-- <app-how-possible-home></app-how-possible-home> -->
<app-our-services></app-our-services>
<app-responsible-company></app-responsible-company>
<app-reviews-home></app-reviews-home>
<!-- <app-gallery></app-gallery> -->
<app-contact-home></app-contact-home>
